import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { UsageLimitsComponent } from 'src/app/popups/usage-limits/usage-limits.component';
import { ProductManagementService } from 'src/service/product-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { FileUploadFor, GalleryType, LocalService, StatusWithId, TriggeredEvent, UsageLimitType } from '../../../service/local.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  message = ''; uploadedFiles: StatusWithId[] = []; isShowProgressBar: boolean = false; @Input() isBigSizeIcon: boolean = false;
  fileToUpload: File = null; progress: number = 0; pendingFiles: FileList; @Input() fileUploadFor: FileUploadFor = FileUploadFor.None;
  allowedFiles: string; ctryCode: string = ''; @Input() isAutoTranslateConfirmatioNeeded = false;
  @Output() onFileUploaded = new EventEmitter(); @Input() forId = ''; @Input() forId2 = ''; @Input() type = 0;
  isUsageLimitConfirmed = false; @Input() Id: string = ''; @Input() forId3: number | string | null = '0';
  @Input() topPosition: number = 0; @Input() isAutoOpen: boolean = false;

  htmlId: string = ''; elementIds: any;

  constructor(private http: HttpClient, public localService: LocalService, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal, private productManagementService: ProductManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      file: 'file-' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.onSetFileType();
    if (this.isAutoOpen) {
      this.onAction(1);
    }
  }

  onSetFileType() {
    switch (this.fileUploadFor) {
      case FileUploadFor.ReceiptIcon: {
        this.allowedFiles = ".jpeg,.jpg,.png";
      } break;
      case FileUploadFor.Gallery: {
        if (this.type == GalleryType.ReceiptFileSample) {
          this.allowedFiles = ".jpeg";
        } else {
          this.allowedFiles = this.type == GalleryType.ReceiptFile ? "*" : ".jpeg,.jpg,.png,.gif";
        }
      } break;
      case FileUploadFor.UserGuide: {
        this.allowedFiles = ".zip";
      } break;
      case FileUploadFor.UserGuideManual: {
        this.allowedFiles = ".txt";
      } break;
      default: {
        this.allowedFiles = '.xlsx';
      } break;
    }
  }

  handleFileInput(event: any) {
    var maxSizeInMb = (3 * 1000) * 1000; //3 MB
    let files: FileList = event.target.files;
    var isMaximumSizeAllowed: boolean = true;

    switch (this.fileUploadFor) {
      case FileUploadFor.Gallery: {
        if (this.type == GalleryType.ReceiptFile) {
          maxSizeInMb = (10 * 1000) * 1000; //10 MB
        }
      } break;
      case FileUploadFor.ReceiptIcon: {
        maxSizeInMb = (0.25 * 100) * 1000; //25kb
      } break;
    }

    switch (this.fileUploadFor) {
      case FileUploadFor.Gallery:
      case FileUploadFor.ReceiptIcon: {
        for (var i = 0; i < files.length; i++) {
          if (files[i].size > maxSizeInMb) {
            isMaximumSizeAllowed = false;
            break;
          }
        }
      } break;
    }

    if (isMaximumSizeAllowed)
      this.onUpload(files);
    else
      this.localService.showInformation(this.localService.languageContent.common.max_limit, true);
  }

  onUpload(files: FileList) {
    this.isUsageLimitConfirmed = false;
    switch (this.fileUploadFor) {
      case FileUploadFor.Products: {
        this.isUsageLimitConfirmed = true;
        this.onUploadConfimed(files);
        // this.productManagementService.getUsageLimits(this.forId, UsageLimitType.BulkUploadProduct).subscribe(result => {
        //   if (result.length == 0) {
        //     this.isUsageLimitConfirmed = true;
        //     this.onUploadConfimed(files);
        //   } else {
        //     const modalRef = this.modalService.open(UsageLimitsComponent);
        //     modalRef.componentInstance.items = result;
        //     this.onUploaded(false);
        //   }
        // });
      } break;
      default: {
        this.isUsageLimitConfirmed = true;
        this.onUploadConfimed(files);
      } break;
    }
  }

  onUploadConfimed(files: FileList) {
    if (this.isAutoTranslateConfirmatioNeeded) {
      const modalRef = this.modalService.open(MessageComponent);
      modalRef.componentInstance.IsConfirmationType = true;
      modalRef.componentInstance.IsHtmlMessage = true;
      modalRef.componentInstance.message = this.localService.languageContent.common.is_auto_translation_confirmation;
      modalRef.result.then((result) => {
        this.onUploadFilesFinal(files, result.event == TriggeredEvent.Ok);
      });
    } else {
      this.onUploadFilesFinal(files);
    }
  }

  onUploadFilesFinal(files: FileList, isAutoTransateAllowed: boolean = false) {
    if (this.isUsageLimitConfirmed) {
      if (this.localService.selected) {
        this.message = "";
        this.uploadedFiles = [] as StatusWithId[];
        this.isShowProgressBar = files.length > 0;
        for (var i = 0; i < files.length; i++) {
          this.message = "Processing";
          this.fileToUpload = files.item(i);
          const formData = new FormData();
          formData.append('file', this.fileToUpload, this.fileToUpload.name);
          let fileData: string = [JSON.stringify(this.localService.getSelected(this.localService.getLoginAsCountryCode() )), this.fileToUpload.name, this.fileUploadFor, this.forId, this.forId2, (isAutoTransateAllowed ? "1" : "0"), this.type.toString(), this.forId3 ?? '0'].join(';');
          this.http.post(this.configurationManagementService.getHostPathForFileUpload(), formData, {
            headers: { fileData: fileData },
            reportProgress: true, observe: 'events'
          }).subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event.type === HttpEventType.Response) {
              this.progress = 0;
              this.message = 'Upload success.';
              if (event.body != null) {
                var uploadedFilesTemp = event.body as StatusWithId[];
                if (uploadedFilesTemp.length > 0)
                  uploadedFilesTemp.forEach((uploadedFile: StatusWithId) => {
                    this.uploadedFiles.push(uploadedFile);
                  });
              }
              /*if (this.uploadedFiles.length == files.length)*/
              this.onUploaded();
            }
          }, error => {
            this.isShowProgressBar = false;
            this.localService.showMessage(this.localService.languageContent.gallery.upload_failed);
          });
        }
      } else {
        this.pendingFiles = files;
      }
    }
  }

  onUploaded(isShowStatus: boolean = true) {
    if (!isShowStatus)
      this.isShowProgressBar = true;
    setTimeout(() => {
      this.isShowProgressBar = false;
    }, isShowStatus ? 0 : 300);
    this.onFileUploaded.emit(this.uploadedFiles);
    if (isShowStatus && this.uploadedFiles.length > 0) {
      this.localService.showInformationByStatus(this.uploadedFiles[0].status);
    }
  }

  onAction(index) {
    switch (index) {
      case 1: {
        setTimeout(() => {
          const id = this.Id && this.Id.trim().length > 1 ? this.Id : this.elementIds.file;
          const element: HTMLInputElement = document.getElementById(id) as HTMLInputElement;
          if (element) {
            element.click();
          }
        }, 200);
      } break;
    }
  }
}
